<template>
  <v-card class="dt-modal">
    <!-- <div class="dt-modal--header">New Contact</div> -->
    <div class="dt-modal--body">
      <v-card>
        <v-layout row wrap>
          <v-flex md12 class="box-container">
            <div class="box-widget selected" style="overflow-y: auto;">
              <div class="box-header gray">
                <div class="box-header--name">{{ wizardSteps[wizardStepNumber] }}</div>
              </div>
              <div class="box-body">
                <v-stepper v-model="wizardStepNumber">
                  <!-- <v-stepper-header>
          <v-stepper-step :complete="wizardStepNumber > 1" step="1">Basic Setup</v-stepper-step>

          <v-divider></v-divider>

          <v-stepper-step :complete="wizardStepNumber > 2" step="2">Venue</v-stepper-step>

          <v-divider></v-divider>

          <v-stepper-step step="3">Promoter</v-stepper-step>
                  </v-stepper-header>-->
                  <v-stepper-items>
                    <v-stepper-content step="1">
                      <v-layout row wrap>
                        <v-flex md6 style="padding:5px;">
                          <div class="form-group">
                            <v-menu
                              :close-on-content-click="false"
                              v-model="startDateMenu"
                              :nudge-right="40"
                              lazy
                              transition="scale-transition"
                              offset-y
                              full-width
                              min-width="290px"
                            >
                              <TextField
                                slot="activator"
                                :id="'startDate'"
                                v-bind="textFieldConfig"
                                v-model="event.booking_start_date"
                                isModel
                                :placeholder="$t('start_date')"
                                @startEditing="e => startDateMenu = true"
                                @validated="onValidation"
                              ></TextField>
                              <v-date-picker
                                :value="event.booking_start_date"
                                v-model="event.booking_start_date"
                                @input="startDateMenu = false"
                              ></v-date-picker>
                            </v-menu>
                            <v-menu
                              :close-on-content-click="false"
                              v-model="endDateMenu"
                              :nudge-right="40"
                              lazy
                              transition="scale-transition"
                              offset-y
                              full-width
                              min-width="290px"
                            >
                              <TextField
                                slot="activator"
                                :id="'endDate'"
                                v-bind="textFieldConfig"
                                v-model="event.booking_end_date"
                                isModel
                                :placeholder="$t('end_date')"
                                @startEditing="e => endDateMenu = true"
                                @validated="onValidation"
                              ></TextField>
                              <v-date-picker
                                :min="event.booking_start_date"
                                :value="event.booking_end_date"
                                v-model="event.booking_end_date"
                                @input="endDateMenu = false"
                              ></v-date-picker>
                            </v-menu>
                            <TextField
                              :id="'city'"
                              v-bind="textFieldConfig"
                              v-model="event.booking_city"
                              required
                              :placeholder="$t('city')"
                            ></TextField>
                            <Dropdown
                              class="dt-dropdown"
                              :options="countries.map(x => { return {text: x, value:x}; })"
                              :selected="{text: selectedItem.venue_country, v54alue:selectedItem.venue_country}"
                              box
                              :placeholder="$t('country')"
                              v-on:selectedChange="e => onDropdownChange('country', e)"
                              :listHeight="150"
                            ></Dropdown>
                            <TextField
                              :id="'event_name'"
                              v-bind="textFieldConfig"
                              v-model="event.booking_date_name"
                              required
                              :placeholder="$t('date_name')"
                            ></TextField>
                            <TextField
                              :id="'event_url'"
                              v-bind="textFieldConfig"
                              v-model="event.booking_event_url"
                              required
                              :placeholder="$t('event_url')"
                            ></TextField>
                            <Dropdown
                              class="dt-dropdown"
                              :options="bookingStatus.map(row => ( {value: row.booking_status_id, text:row.booking_status_name} ))"
                              :selected="{value: selectedBookingStatus.booking_status_id, text:selectedBookingStatus.booking_status_name}"
                              box
                              :placeholder="$t('status')"
                              v-on:selectedChange="e => onDropdownChange('booking_status', e)"
                              :listHeight="150"
                            ></Dropdown>
                            <TextField
                              :id="'lineup'"
                              textarea
                              :height="80"
                              v-bind="textFieldConfig"
                              :placeholder="$t('lineup')"
                              @valuechanged="onTextFieldValueChange"
                              @validated="onValidation"
                              v-model="event.booking_lineup"
                            ></TextField>
                            <TextField
                              :id="'doors_open'"
                              v-bind="textFieldConfig"
                              v-model="event.booking_doors_open"
                              required
                              :placeholder="$t('doors_open')"
                            ></TextField>
                            <TextField
                              :id="'booking_curfew'"
                              v-bind="textFieldConfig"
                              v-model="event.booking_curfew"
                              required
                              :placeholder="$t('curfew')"
                            ></TextField>
                            <TextField
                              :id="'crew_get_in'"
                              v-bind="textFieldConfig"
                              v-model="event.booking_get_in"
                              required
                              :placeholder="$t('crew_get_in')"
                            ></TextField>
                            <TextField
                              v-for="(item, index) in customFieldsBooking"
                              :item="item"
                              :index="index"
                              :key="item.custom_field_id"
                              :id="'booking_cf_'+item.custom_field_id"
                              v-model="customFieldsBooking[index].field_value"
                              v-bind="textFieldConfig"
                              required
                              :placeholder="item.field_label"
                            ></TextField>
                          </div>
                        </v-flex>
                        <v-flex md6>
                          <!-- <div
                            class="form-group"
                            v-for="(item, index) in event.artists"
                            :key="item.artist_id"
                            :index="index"
                          >
                            <TextField
                              v-bind="textFieldConfig"
                              v-model="event.artists[index].artist_name"
                              required
                              :placeholder="$t('artist')"
                            ></TextField>
                            <v-divider inset></v-divider>
                          </div>-->
                          <v-expansion-panel v-model="panelArtists" expand>
                            <v-expansion-panel-content
                              v-for="(item, index) in event.artists"
                              :key="item.artist_id"
                              :index="index"
                            >
                              <div slot="header">{{$t('artist') + ' : ' + item.artist_name}}</div>
                              <v-card>
                                <v-card-text>
                                  <TextField
                                    :id="'first_offer_notes'+item.artist_id"
                                    v-bind="textFieldConfig"
                                    v-model="event.artists[index].first_offer_notes"
                                    required
                                    :placeholder="$t('first_offer')"
                                  ></TextField>
                                  <TextField
                                    :id="'performance_time'+item.artist_id"
                                    v-bind="textFieldConfig"
                                    v-model="event.artists[index].performance_time"
                                    required
                                    :placeholder="$t('pfm_time')"
                                  ></TextField>
                                  <TextField
                                    :id="'performance_time_contract'+item.artist_id"
                                    v-bind="textFieldConfig"
                                    v-model="event.artists[index].performance_time_contract"
                                    required
                                    :placeholder="$t('playtime')"
                                  ></TextField>
                                  <TextField
                                    :id="'artist_soundcheck'+item.artist_id"
                                    v-bind="textFieldConfig"
                                    v-model="event.artists[index].artist_soundcheck"
                                    required
                                    :placeholder="$t('soundcheck')"
                                  ></TextField>
                                  <TextField
                                    :id="'artist_before'+item.artist_id"
                                    v-bind="textFieldConfig"
                                    v-model="event.artists[index].artist_before"
                                    required
                                    :placeholder="$t('artist_before')"
                                  ></TextField>
                                  <TextField
                                    :id="'artist_after'+item.artist_id"
                                    v-bind="textFieldConfig"
                                    v-model="event.artists[index].artist_after"
                                    required
                                    :placeholder="$t('artist_after')"
                                  ></TextField>
                                  <TextField
                                    :id="'artist_stage_floor'+item.artist_id"
                                    v-bind="textFieldConfig"
                                    v-model="event.artists[index].artist_stage_floor"
                                    required
                                    :placeholder="$t('stage_floor')"
                                  ></TextField>
                                </v-card-text>
                              </v-card>
                            </v-expansion-panel-content>
                          </v-expansion-panel>
                        </v-flex>
                      </v-layout>
                    </v-stepper-content>

                    <v-stepper-content step="2">
                      <v-layout row wrap>
                        <v-flex md6>
                          <div class="box-widget selected" style="margin:5px;">
                            <div class="box-header gray">
                              <div
                                class="box-header--name"
                              >{{ $t('request_venue') + event.venue_name }}</div>
                            </div>
                            <div class="box-body">
                              <div class="dt-page--data-table">
                                <v-data-table
                                  :items="requestVenueInfo"
                                  hide-actions
                                  hide-headers
                                  class="dt-table booking-table elevation-1"
                                >
                                  <template slot="items" slot-scope="props">
                                    <tr class="booking-request-row">
                                      <td>{{props.item['label']}}</td>
                                      <td>{{props.item['value']}}</td>
                                    </tr>
                                  </template>
                                </v-data-table>
                              </div>
                            </div>
                          </div>
                        </v-flex>
                        <v-flex md6>
                          <div class="box-widget selected" style="margin:5px;">
                            <div class="box-header gray">
                              <div
                                class="box-header--name"
                              >{{ $t('existing_venue') + event.venue_name }}</div>
                            </div>
                            <div class="box-body">
                              <v-card>
                                <v-card-text>
                                  <div class="form-group">
                                    <TextField
                                      :id="'venue_address1'"
                                      v-bind="textFieldConfig"
                                      v-model="event.venue_address1"
                                      required
                                      :placeholder="$t('address1')"
                                    ></TextField>
                                    <TextField
                                      :id="'venue_address2'"
                                      v-bind="textFieldConfig"
                                      v-model="event.venue_address2"
                                      required
                                      :placeholder="$t('address2')"
                                    ></TextField>
                                    <TextField
                                      :id="'venue_city'"
                                      v-bind="textFieldConfig"
                                      v-model="event.venue_city"
                                      required
                                      :placeholder="$t('city')"
                                    ></TextField>
                                    <TextField
                                      :id="'venue_postalcode'"
                                      v-bind="textFieldConfig"
                                      v-model="event.venue_postalcode"
                                      required
                                      :placeholder="$t('postal_code')"
                                    ></TextField>
                                    <TextField
                                      :id="'venue_phone1'"
                                      v-bind="textFieldConfig"
                                      v-model="event.venue_phone1"
                                      required
                                      :placeholder="$t('phone1')"
                                    ></TextField>
                                    <TextField
                                      :id="'venue_url1'"
                                      v-bind="textFieldConfig"
                                      v-model="event.venue_url1"
                                      required
                                      :placeholder="$t('url1')"
                                    ></TextField>
                                    <TextField
                                      :id="'venue_capacity'"
                                      v-bind="textFieldConfig"
                                      v-model="event.venue_capacity"
                                      required
                                      :placeholder="$t('capacity')"
                                    ></TextField>
                                  </div>
                                </v-card-text>
                              </v-card>
                            </div>
                          </div>
                        </v-flex>
                      </v-layout>
                    </v-stepper-content>

                    <v-stepper-content step="3">
                      <v-card class="mb-5" color="grey lighten-1" height="200px"></v-card>

                      <v-btn color="primary" @click="wizardStepNumber = 1">{{$t('continue')}}</v-btn>

                      <v-btn flat>{{$t('cancel')}}</v-btn>
                    </v-stepper-content>
                  </v-stepper-items>
                </v-stepper>
              </div>
            </div>
          </v-flex>
        </v-layout>
      </v-card>
    </div>

    <div class="dt-modal--options">
      <v-layout row wrap>
        <v-flex md6 class="text-xs-left">
          <button
            class="dt-button v1 s1"
            @click="wizardStepNumber--"
            v-if="wizardStepNumber > 1"
          >{{$t('back')}}</button>
          
          <button class="dt-button s1" @click.stop="onCancel"> {{$t('cancel')}} </button>
        </v-flex>

        <v-flex md6 class="text-xs-right">
          <button
            class="dt-button s1"
            v-if="wizardStepNumber <= Object.keys(wizardSteps).length"
            @click="wizardStepNumber++"
          > {{$t('next')}} </button>
        </v-flex>
      </v-layout>
    </div>
  </v-card>
</template>

<script>
import {
  BookingStoreNamespace as storeNS,
  BookingStoreNamespace
} from "../store";
import * as ActionTypes from "../store/types";

import { mapGetters, mapActions } from "vuex";

import DetailsTable from "../../../plugins/datatable/datatable";
import TextField from "@plugins/text-field/text-field";
// import { createValidator } from "@plugins/text-field";

import isEmail from "validator/lib/isEmail";
// import { BookingService } from "../services/booking-service";

import Dropdown from "@plugins/dropdown/dropdown";

import DtTab from "@plugins/tab/tab";

import { addRemoveSet } from "../../../utility";
import InputField from "../../../plugins/text-field/input-field";
import { Subject, concat } from "rxjs";
import { distinctUntilChanged, debounceTime } from "rxjs/operators";
import {
  createValidator,
  resultValidity,
  EventHooks,
  validate
} from "../../../plugins/text-field";

import { bookingRequestsService } from "../services/booking-requests.service";

export default {
  props: ["calendarDateId", "selectedRequest", "selectedItem"],
  components: {
    TextField,
    Dropdown,
    InputField,
    DtTab
  },
  data: function() {
    return {
      wizardStepNumber: 1,
      wizardSteps: { 1: "Basic Setup", 2: "Venue", 3: "Promoter" },
      requestDetails: {},
      countries: [],
      selectedCountry: "",
      bookingStatus: [],
      selectedBookingStatus: {},

      event: {
        calendar_date_id: "",
        artist_id: "",
        artists: [],
        artist_name: "",
        first_offer_notes: "",
        performance_time: "",
        performance_time_contract: "",
        artist_before: "",
        artist_after: "",
        artist_stage_floor: "",
        artist_soundcheck: "",
        booking_start_date: "",
        booking_end_date: "",
        booking_date_name: "",
        booking_event_url: "",
        booking_city: "",
        booking_country: "",
        booking_lineup: "",
        booking_doors_open: "",
        booking_curfew: "",
        booking_get_in: "",

        contact_id: "",

        promoter_id: "",
        promoter_company_name: "",
        promoter_company_legalname: "",
        promoter_address1: "",
        promoter_address2: "",
        promoter_city: "",
        promoter_postalcode: "",
        promoter_country: "",
        promoter_phone1: "",
        promoter_phone2: "",
        promoter_email1: "",
        promoter_vat_no: "",
        promoter_tax_no: "",

        venue_address1: "",
        venue_address2: "",
        venue_capacity: "",
        venue_city: "",
        venue_country: "",
        venue_id: "",
        venue_name: "",
        venue_phone1: "",
        venue_postalcode: "",
        venue_url1: ""
      },

      customFieldsBooking: {},
      customFieldsArtist: {},
      customFieldsContact: {},
      customFieldsPromoter: {},
      customFieldsVenue: {},

      panelArtists: [true],

      startDate: this.selectedItem.booking_start_date,
      startDateMenu: null,
      endDate: null,
      endDateMenu: null,

      requestVenueInfo: [
        {
          label: "Address",
          value: "Savar Dhaka"
        }
      ],

      textFieldConfig: {
        height: 42,
        showEditIconOnHover: false,
        box: true,
        showValidationIcons: true
      },
      person: createPerson(),
      emailValidators: [
        createValidator({
          name: "emailValidation",
          validatorFn: isEmail,
          errorMessage: "Must be a valid Email"
        })
      ],
      groups: [],
      validationResult: {},
      person: {
        firstName: "",
        lastName: "",
        email: "",
        phone: "",
        groups: []
      }
    };
  },
  mounted: function() {
    // BookingService.findContactGroups().then(res => {
    //   this.groups = res.groups.map(e => ({
    //     text: e.group_name,
    //     value: e.group_id
    //   }));
    // });
    // console.log("cdate id in child", this.calendarDateId);
    // Object.keys(this.selectedItem).forEach(key => {
    //   if (key in this.event) {
    //     this.event[key] = this.selectedItem[key];
    //   }
    // });
    // console.log("olo ", this.event);
    // this.event.booking_start_date = selectedItem.booking_start_date;
  },
  created: function() {
    console.log("cdate id in child", this.calendarDateId);
  },
  computed: {
    isFormValid: function() {
      return Object.values(this.validationResult).every(e => e.valid);
    }
  },
  watch: {
    wizardStepNumber: function(newValue, oldValue) {
      if (newValue > Object.keys(this.wizardSteps).length) {
        this.wizardStepNumber = 1;
      }
    },
    selectedItem: function(nv, ov) {
      this.setEventStates(this.selectedItem);
      bookingRequestsService
        .getBookingRequest(
          this.selectedItem.calendar_date_id,
          this.selectedItem.artist_id
        )
        .then(res => {
          this.requestDetails = res.data;
          this.requestDetails.cdate.artists = JSON.parse(
            this.requestDetails.cdate.artists
          );
          this.setEventStates(this.requestDetails.cdate);
          this.countries = this.requestDetails.countries;
          this.selectedCountry = this.requestDetails.venue_country;
          this.bookingStatus = this.requestDetails.statuses;
          this.selectedBookingStatus = this.bookingStatus.find(
            e => e.default_status_booking_flag == "1"
          );

          this.setCustomFields(this.requestDetails);
          this.setRequestedVenueInfo();

          console.log(this.requestDetails);
        });
    }
  },
  methods: {
    ...mapActions(storeNS, {
      [ActionTypes.FETCH_MANY_CONTACTS]: ActionTypes.FETCH_MANY_CONTACTS
    }),

    setEventStates(obj) {
      Object.keys(obj).forEach(key => {
        if (key in this.event) {
          this.event[key] = obj[key];
        }
      });

      this.event.booking_end_date = obj.booking_start_date;
      this.event.booking_city = obj.venue_city;
      this.event.booking_country = obj.venue_country;

      // this.event.venue_id = this.requestDetails['location']['booking_location_id'];
    },

    setCustomFields(request_details) {
      // this.customFieldsBooking = request_details.booking_cf.map(row => {
      //   return { text: x, value: x };
      // });

      this.customFieldsBooking = request_details.booking_cf
        .filter(row =>
          Object.keys(request_details.cdate).includes(
            "booking_cf_" + row.custom_field_id
          )
        )
        .map(row => {
          row.field_value =
            request_details.cdate["booking_cf_" + row.custom_field_id];
          return row;
        });

      // console.log("Booking Customs", this.customFieldsBooking);
    },

    setRequestedVenueInfo() {
      // let infos = [
      //   { [$t('address1')] : this.event.venue_address1},
      //   { [$t('address2')] : this.event.venue_address2},
      //   { [$t('city')] : this.event.venue_city},
      //   { [$t('postal_code')] : this.event.venue_postalcode},
      //   { [$t('address1')] : this.event.venue_address1},
      //   { [$t('phone1')] : this.event.venue_phone1},
      //   { [$t('url1')] : this.event.venue_url1},
      //   { [$t('capacity')] : this.event.venue_capacity},
      //   { [$t('address1')] : this.event.venue_address1}
      // ];
      let infos = [
        { label: "Address", value: this.event.venue_address1 },
        { label: "Address 2", value: this.event.venue_address2 },
        { label: "City", value: this.event.venue_city },
        { label: "Postal Code", value: this.event.venue_postalcode },
        { label: "Phone", value: this.event.venue_phone1 },
        { label: "Url", value: this.event.venue_url1 },
        { label: "Capacity", value: this.event.venue_capacity }
      ];

      this.requestVenueInfo = infos;
    },

    onTextFieldValueChange: function(key, value) {
      this.person[key] = value;
    },
    onValidation: function(name, value) {
      this.$set(this.validationResult, name, value);
      // console.log(this.validationResult);
    },
    onCancel: function() {
      this.$emit("cancelled", true);
    },
    onDropdownChange: function(name, event) {
      switch (name) {
        case "country": {
          console.log(event);
          this.selectedCountry = event;
          break;
        }
        case "status": {
          this.selectedStatus = event;
          break;
        }
        default: {
        }
      }
    },
    addNewContact: function(e) {
      this.$emit("new_contact", this.person);
    }
  }
};

const createPerson = ({
  firstName = "",
  lastName = "",
  email = "",
  phone = "",
  group
} = {}) => {
  return {
    firstName,
    lastName,
    email,
    phone,
    group
  };
};
</script>

<style lang="scss" scoped>
.form-group {
  display: flex;
  flex-direction: column;
  .dt-input-box {
    flex: 1;
    margin: 5px;
    margin-left: 0px;
  }

  .group-input {
    margin-top: 25px;
    margin-bottom: 10px;
    margin-right: 5px;
  }
}

.dt-modal--options {
  button {
    height: 30px;
  }
}
</style>
